import React from 'react';
import { Breadcrumb } from '@layouts/HeaderBar/components/Breadcrumb';
import { SubMenu, SubMenuMobile } from './components/SubMenu';
import { useFetchBreadcrumbQuery } from './HeaderBar.service';
import classNames from 'classnames';
import { SubNavigation } from '@layouts/Header/Header.types';

interface HeaderBarProps {
  subNavigation: SubNavigation;
}

const HeaderBar = ({ subNavigation }: HeaderBarProps) => {
  const { data: breadcrumb, isLoading } = useFetchBreadcrumbQuery();
  return (
    <div id='c-headerbar' className='c-headerbar'>
      <div className={classNames('c-headerbar-container', { loading: isLoading })}>
        {subNavigation.SubNavType === 'Breadcrumb' && <Breadcrumb breadcrumb={breadcrumb} />}
      </div>
      <div className='c-headerbar-container page-with-submenu'>
        {subNavigation.SubNavType === 'SubMenu' && subNavigation.content && (
          <div>
            <SubMenu submenuLinks={subNavigation.content} />
            <SubMenuMobile submenuLinks={subNavigation.content} title={subNavigation.Title} />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderBar;
